"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
require("react");
const TreeLeaf_1 = tslib_1.__importDefault(require("./TreeLeaf"));
const excludeFromList_1 = require("./excludeFromList");
const TreeLeafList = (props) => {
    const { leafList, hasMultiselect, showRadioButtons, selectedItems, selectedGroups, onSelectionChange } = props;
    const handleItemSelection = (itemId) => {
        const isSelected = selectedItems.includes(itemId);
        const newSelectedItems = isSelected
            ? (0, excludeFromList_1.excludeFromList)(selectedItems, itemId)
            : [...selectedItems, itemId];
        onSelectionChange(newSelectedItems, selectedGroups);
    };
    const handleSetItemActive = (itemId) => onSelectionChange([itemId], []);
    return leafList.map(item => ((0, jsx_runtime_1.jsx)(TreeLeaf_1.default, { item: item, hasMultiselect: hasMultiselect, showRadioButtons: showRadioButtons, isSelected: selectedItems.includes(item.id), onSelectItem: () => handleItemSelection(item.id), onActiveItem: () => handleSetItemActive(item.id) }, item.id)));
};
TreeLeafList.displayName = 'TreeLeafList';
exports.default = TreeLeafList;
